import React, { useContext } from 'react';
import styled from 'astroturf/react';
import pluralize from 'pluralize';
import { FeedContext } from 'js/social/contexts/feed';
import { FollowableUser } from 'js/social/shared/types';
import AvatarBase from 'js/social/shared/Avatar';
import { Button } from 'js/design_system/Button';
import { ButtonLink } from 'js/design_system/link/ButtonLink';
import { Body } from 'js/design_system/Body';
import { createUserFollowing } from 'js/social/api/user_following_api';

const ToolTipContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 8px;
`;

const BodyBlack = styled(Body)`
  color: $ds-black;
`;

const FollowerBody = styled(Body)`
  color: $ds-gray-dark;
  margin-top: 4px;
`;

const StyledFollowButton = styled(Button)`
  height: 32px;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
`;

const StyledProfileButton = styled(ButtonLink)`
  height: 32px;
  border: 1px solid #b4c7e8;
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
`;

const UserContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 8px;
`;

const Avatar = styled(AvatarBase)`
  --size: 56px;
`;
interface Props {
  user: Partial<FollowableUser>;
}

export const UserTooltip: React.FC<Props> = ({ user }) => {
  const {
    userActions: { setUserFollowing },
  } = useContext(FeedContext);

  return (
    <ToolTipContainer>
      <UserContentContainer>
        <Avatar
          // @ts-ignore
          fullName={user.displayName}
          photoUrl={user.photo || ''}
          profileUrl={user.url}
        />
        <div>
          <BodyBlack size="md" bold>
            {user.displayName}
          </BodyBlack>
          {user.university && (
            <BodyBlack size="sm">{user.university?.displayName}</BodyBlack>
          )}
          {user.followers && user.followers > 0 && (
            <FollowerBody size="sm">
              {`${user.followers} ${pluralize('follower', user.followers)}`}
            </FollowerBody>
          )}
        </div>
      </UserContentContainer>
      {user.following === false ? ( // because it could be undefined, in which case we want the url
        <StyledFollowButton
          onClick={() => {
            if (user.id) {
              createUserFollowing(user.id, 'user_tag').then(() =>
                setUserFollowing(user.id || -1, true),
              );
            }
          }}
        >
          Follow
        </StyledFollowButton>
      ) : (
        <StyledProfileButton secondary href={user.url}>
          View Profile
        </StyledProfileButton>
      )}
    </ToolTipContainer>
  );
};

export default UserTooltip;
